import React from "react";

import {cn} from "@isudio/utils";

const RowGrid: React.FC<React.PropsWithChildren<{
  className?: string
}>> = ({
         className,
         children,
       }) => (
  <div
    className={cn("row w-full gap-4 grid grid-cols-1 sm:grid-cols-2 ", className)}>
    {children}
  </div>
);

RowGrid.displayName = "Row";
export {RowGrid};